import axios from "axios";
import { 
    CREATE_CHANGE_LOG,
    UPDATE_CHANGE_LOG,
    DELETE_CHANGE_LOG,
    FETCH_CHANGE_LOGS,
    FETCH_RECENT_CHANGE_LOGS,
    GET_CHANGE_LOGS,
    interceptor
} from ".";

import store from "../store";
interceptor(axios, store);

export function createChangeLog(changeLog) {
    return {
      type: CREATE_CHANGE_LOG,
      payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/change_log/createChangeLog`, changeLog, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }
  
  export function updateChangeLog(changeLog) { 
    return {
      type: UPDATE_CHANGE_LOG,
      payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/change_log/updateChangeLog/${changeLog.id}`, changeLog, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }
  
  export function deleteChangeLog(selected) {
    return {
      type: DELETE_CHANGE_LOG,
      payload: axios.delete(`${process.env.REACT_APP_API_ENDPOINT}/core/change_log/deleteChangeLog/${selected}`, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }
  
  export function fetchChangeLogs() {
    return {
      type: FETCH_CHANGE_LOGS,
      payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/change_log/getChangeLogs/`, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }

  export function fetchRecentChangeLogs() {
    return {
      type: FETCH_RECENT_CHANGE_LOGS,
      payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/change_log/getRecentChangeLogs/`, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }

  export function getChangeLogs(changeLogId) {
    return {
      type: GET_CHANGE_LOGS,
      payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/change_log/getChangeLogs/${changeLogId}`, {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      })
    };
  }